import React from 'react';

import {store, StoreProvider} from './src/base/root-store';
import {IconProvider} from '../patterns';

import '../patterns/components/icon/icon/icons';
import {ErrorBoundary} from './src/base/ErrorBoundary';
import * as Sentry from '@sentry/react';
import {AppRouter} from './src/base/AppRouter';

export const App = Sentry.withProfiler(() => (
    <StoreProvider value={store}>
        <IconProvider getPath={(name: string): string => '/svg/icons.svg#' + name}>
            <ErrorBoundary standalone={true}>
                <AppRouter/>
            </ErrorBoundary>
        </IconProvider>
    </StoreProvider>
));
